import React from 'react'
import "./Testimonial.css";
import Testimonial1 from '../images/testi.jpg';
import profile from '../images/png/Ellipse1.png'
const Testimonial=()=>{
  return (
    <div>
        <div className='testimonial'>
            <div className='testi'>
                <div className='testiWords'>
                    <h1>Testimonials</h1>
                    <p>  Words from our clients</p>
                </div>
                <div className='google'>
                    <button type="submit">Google</button>
                    <button type="submit">Facebook</button>
                    <button type="submit">Weddingwire</button> 
                    <button type="submit">WedmeGood</button>
                </div>
            </div>
            <div className='testicard'>
                <div className='testimg'>
                    <img src={Testimonial1} alt=""/>
                </div>
                <div className='client'>
                    <div className='clientprofile'>
                        <img src={profile} alt=""/>
                    </div>
                    <p>Lorem ipsum dolor sit <br/> amet, consectetuer<br/> adipiscing elit, sed <br/>diam nonummy nibh<br/> euismod tincidunt ut<br/>laoreet</p>
                    
                </div>
                <div className='client'>
                    <div className='clientprofile'>
                        <img src={profile} alt=""/>
                    </div>
                    <p>Lorem ipsum dolor sit <br/> amet, consectetuer<br/> adipiscing elit, sed <br/>diam nonummy nibh<br/> euismod tincidunt ut<br/>laoreet</p>
                    
                </div>
                <div className='client'>
                    <div className='clientprofile'>
                        <img src={profile} alt=""/>
                    </div>
                    <p>Lorem ipsum dolor sit <br/> amet, consectetuer<br/> adipiscing elit, sed <br/>diam nonummy nibh<br/> euismod tincidunt ut<br/>laoreet</p>
                    
                </div>
                <div className='client'>
                    <div className='clientprofile'>
                        <img src={profile} alt=""/>
                    </div>
                    <p>Lorem ipsum dolor sit <br/> amet, consectetuer<br/> adipiscing elit, sed <br/>diam nonummy nibh<br/> euismod tincidunt ut<br/>laoreet</p>
                    
                </div>
                
            </div>
            
        </div>
    </div>
  )
}
export {Testimonial}
